import { inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ICreateInventoryProductResponse } from "../../types";

// 1. Thunk for saving product
export const saveInventoryProduct = createServiceAsyncThunk<
  ICreateInventoryProductResponse,
  { formData: FormData }
>(
  ACTION_NAMES.SAVE_INVENTORY_PRODUCT,
  ({ formData }) => inventoryProductService.createInventoryProduct(formData),
  ERROR_MESSAGES.SAVE_INVENTORY_PRODUCT_FAILURE
);

// 2. Generic Slice
const saveInventoryProductSlice = createGenericSlice<
  ICreateInventoryProductResponse,
  { formData: FormData }
>(
  SLICE_NAMES.SAVE_INVENTORY_PRODUCT_SLICE,
  saveInventoryProduct
);

export const {
  clearError: clearSaveInventoryProductError,
  clearSuccessMessage: clearSaveInventoryProductSuccessMessage,
} = saveInventoryProductSlice.actions;

export default saveInventoryProductSlice.reducer;
